import { useState, useCallback } from 'react';

const useForm = (initialValues = {}, validate) => {
  const [values, setValues] = useState(initialValues || {});
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = useCallback(
    (event) => {
      const { name, value } = event.target;
      setValues((prev) => {
        const newValues = { ...prev, [name]: value };
        return newValues;
      });
    },
    []
  );

  const handleSubmit = useCallback(
    (onSubmit) => async (event) => {
      if (event && typeof event.preventDefault === 'function') {
        event.preventDefault();
      } else {
        console.error('useForm: Invalid event object:', event);
      }
      setIsSubmitting(true);
      const validationErrors = validate ? validate(values) : {};
      setErrors(validationErrors);

      if (Object.keys(validationErrors).length === 0) {
        try {
          await onSubmit(values);
        } catch (error) {
          setErrors({ submit: error.message });
        }
      }
      setIsSubmitting(false);
    },
    [values, validate]
  );

  const resetForm = useCallback(() => {
    setValues(initialValues || {});
    setErrors({});
    setIsSubmitting(false);
  }, [initialValues]);

  return {
    values,
    errors,
    isSubmitting,
    handleChange,
    handleSubmit,
    resetForm,
  };
};

export default useForm;